export default __webpack_public_path__ + "static/media/buy_plan_banner_vn_desktop.eb5321f5.webp";